import { render, staticRenderFns } from "./ArticlePlayer.vue?vue&type=template&id=12011b1a&"
import script from "./ArticlePlayer.vue?vue&type=script&lang=ts&"
export * from "./ArticlePlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports